import { Vec2 } from './vec2';
export class Rectangle {
    constructor(x, y, w, h) {
        this.left = x;
        this.top = y;
        this.width = w;
        this.height = h;
    }
    moveTo(x, y) {
        this.left = x;
        this.top = y;
    }
    resize(w, h) {
        this.width = w;
        this.height = h;
    }
    get right() { return this.left + this.width; }
    get bottom() { return this.top + this.height; }
    /*
      This function checks to see if a point is inside this rectangle.
  
      X,Y is inclusive (meaning you can have a dot right on the left border and it will be true)
      W,H is exclusive (meaning if the dot is on the right border it will be false)
  
       +---------------+
       |               |
       |        •      |
       |               |
       |               |
       |               |
     y +---------------+
       x
    */
    isPointInside(x, y) {
        return x >= this.left && x < this.right && y >= this.top && y < this.bottom;
    }
    /*
      This function checks to see if a rectangle is inside this rectangle.
  
       +---------------+
       |  +---------+  |
       |  |         |  |
       |  |         |  |
       |  |         |  |
       |  +---------+  |
     y +---------------+
      x
    */
    isRectangleInside(rect) {
        return (this.isPointInside(rect.left, rect.top)) && (this.isPointInside(rect.right, rect.bottom));
    }
    /*
      This function allows you to map a world point to a relative point inside this rectangle
       +---------------+
       |  +---------+  |
       |  |         |  |
       |  |    •    |  |
       |  |         |  |
       |  +---------+  |
     y +---------------+
      x
    */
    mapPoint(x, y) {
        return new Vec2(x - this.left, y - this.top);
    }
    /*
       +---------------+
       |               |
       |               |
       |       +---------------+
       |       |       |       |
       |       |       |       |
     y +-------|-------+       |
       x       |               |
               |               |
               +---------------+
    */
    isRectangleOverlap(rect) {
        return !(rect.left > this.right ||
            rect.right < this.left ||
            rect.top > this.bottom ||
            rect.bottom < this.top);
    }
}
//# sourceMappingURL=Rectangle.js.map